import { render, staticRenderFns } from "./MainBody.vue?vue&type=template&id=59370e34&scoped=true"
import script from "./MainBody.vue?vue&type=script&lang=js"
export * from "./MainBody.vue?vue&type=script&lang=js"
import style0 from "./MainBody.vue?vue&type=style&index=0&id=59370e34&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59370e34",
  null
  
)

export default component.exports